module.exports = __webpack_public_path__ + "static/media/NoEventsInformation.svg";